/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { Log } from '../logging/Log';
import { DeviceModel } from './DeviceModel';
import { MessageService } from './MessageService';

export class SystemInfo {
    private static TAG = 'SystemInfo';

    // eslint-disable-next-line class-methods-use-this
    public getSystemInfo() {
        return new Promise((resolve, reject) => {
            if (DeviceModel.isTizenPlatform()) {
                new MessageService(MessageService.GET_SYSTEM_INFO)
                    .getResponse()
                    .then((response) => {
                        Log.i(SystemInfo.TAG, 'SystemInfo response', response);
                        resolve(response);
                    })
                    .catch((error) => {
                        Log.e(SystemInfo.TAG, 'Failed to get SystemInfo.', error);
                        reject(error);
                    });
            } else {
                resolve({});
            }
        });
    }
}
